<div class="main-table">
  <div class="main-table-toolbar">
    <div class="main-toolbar-container">
      <div class="main-toolbar-add"></div>
      <div class="main-toolbar-spacer"></div>
      <div class="main-toolbar-filter-container"></div>
    </div>

    <div class="table-container mat-elevation-z4">
      <table mat-table [dataSource]="(globalMetaData$ | async) || []" [trackBy]="trackById">

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              [checked]="isSelected(row.id)"
              (change)="toggle(row.id, $event)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let globalMetaData">{{ globalMetaData.id }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let row"> {{ row.name }} </td>
        </ng-container>

        <!-- Description Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef> Description </th>
          <td mat-cell *matCellDef="let row"> {{ row.description }} </td>
        </ng-container>

        <ng-container matColumnDef="fieldConfigName">
          <th mat-header-cell *matHeaderCellDef>Feld-Name</th>
          <td mat-cell *matCellDef="let globalMetaData">
             
            @for (field of globalMetaData.fieldConfig; track field) {
              <span class="badge badge-dark me-1">
                {{ field.name }}
              </span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="fieldConfigDatatype">
          <th mat-header-cell *matHeaderCellDef>Feld-Datentyp</th>
          <td mat-cell *matCellDef="let globalMetaData">
             
            @for (field of globalMetaData.fieldConfig; track field) {
              <span class="badge badge-dark me-1">
                {{ field.datatype }}
              </span>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator [length]="totalItems || 0" [pageSize]="pageSize" [pageSizeOptions]="[25, 50, 100]"></mat-paginator>
    </div>
  </div>
</div>
